export default {"src":"/_next/static/image/public/images/icons3/3.14f6de8ac5b2808e39b2a959f97c286f.svg","height":72,"width":72};